import React from 'react';
import { Routes, Route } from 'react-router';
import { BrowserRouter } from 'react-router-dom';
import { JobPage } from '.';
import { AccountIntegration } from '../../entities/AccountIntegration';
import { JobPageTab } from './JobPageTab';
import { FeatureFlagContext } from '../../contexts/FeatureFlagContext';

interface PropTypes {
  atsSignableOfferEnabled: boolean;
  atsHrisExportV2Enabled: boolean;
  atsUpdateSchedulingUserIntegrationUserInfoEnabled: boolean;
  jobBoardEnabled: boolean;
  duplicateJobEnabled: boolean;
  standardNpsCalculation: boolean;
  emailAccountIntegration: AccountIntegration;
  jobPipelineTriggerIconEnabled: boolean;
  selfSchedulingLinkOptionsEnabled: boolean;
  offerRequisitionFlowEnabled: boolean;
}

function JobPageTabRouter(props: PropTypes & { activeTab: JobPageTab }) {
  return (
    <FeatureFlagContext.Provider
      value={{
        atsHrisExportV2Enabled: props.atsHrisExportV2Enabled,
        atsUpdateSchedulingUserIntegrationUserInfoEnabled:
          props.atsUpdateSchedulingUserIntegrationUserInfoEnabled,
      }}
    >
      <JobPage
        activeTab={props.activeTab}
        atsSignableOfferEnabled={props.atsSignableOfferEnabled}
        atsHrisExportV2Enabled={props.atsHrisExportV2Enabled}
        emailAccountIntegration={props.emailAccountIntegration}
        jobBoardEnabled={props.jobBoardEnabled}
        duplicateJobEnabled={props.duplicateJobEnabled}
        standardNpsCalculation={props.standardNpsCalculation}
        selfSchedulingLinkOptionsEnabled={
          props.selfSchedulingLinkOptionsEnabled
        }
        offerRequisitionFlowEnabled={props.offerRequisitionFlowEnabled}
      />
    </FeatureFlagContext.Provider>
  );
}

export default function JobPageRouter(props: PropTypes) {
  return (
    <BrowserRouter>
      <Routes>
        <Route path={'jobs'}>
          <Route
            path={':id/overview'}
            element={<JobPageTabRouter {...props} activeTab='Overview' />}
          />
          <Route
            path={':id/pipeline'}
            element={<JobPageTabRouter {...props} activeTab='Pipeline' />}
          />
          <Route
            path={':id/paid_job_boards'}
            element={
              <JobPageTabRouter {...props} activeTab='Paid Job Boards' />
            }
          />
          <Route
            path={':id'}
            element={<JobPageTabRouter {...props} activeTab='Pipeline' />}
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
